import { render, staticRenderFns } from "./Weight.vue?vue&type=template&id=adb523f2&scoped=true"
import script from "./Weight.vue?vue&type=script&lang=js"
export * from "./Weight.vue?vue&type=script&lang=js"
import style0 from "./Weight.vue?vue&type=style&index=0&id=adb523f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb523f2",
  null
  
)

export default component.exports